import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs } from 'ws-scripts/modules/common';
import { formatContentForDisplay } from '../utilities/formatting';

const Content = ({ hours, labels, contentColor }) => {
	const { showOpenTodayUntil } = usePrefs();

	return (
		<span className={setClassNames([contentColor, 'today-hours-content'])}>
			{formatContentForDisplay(showOpenTodayUntil, hours, labels)}
		</span>
	);
};

Content.propTypes = {
	hours: PropTypes.string,
	labels: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired,
	contentColor: PropTypes.string
};

export default Content;
